import { useTranslation } from 'react-i18next';

import styles from './SimpleHorizonSelector.module.scss';

export type SimpleHorizon = '1D' | '1W' | '1M' | '3M' | '6M' | '12M';

interface SimpleHorizonSelectorProps {
  horizons: SimpleHorizon[];
  selectedHorizon: SimpleHorizon;
  handleHorizonChange: (horizon: SimpleHorizon) => void;
}

export const SimpleHorizonSelector = ({
  horizons,
  selectedHorizon,
  handleHorizonChange,
}: SimpleHorizonSelectorProps) => {
  const { t } = useTranslation(['scenario']);

  const horizonTranslationMap: Record<SimpleHorizon, string> = {
    '1D': t('scenario:filters.horizons.1d'),
    '1W': t('scenario:filters.horizons.1w'),
    '1M': t('scenario:filters.horizons.1m'),
    '3M': t('scenario:filters.horizons.3m'),
    '6M': t('scenario:filters.horizons.6m'),
    '12M': t('scenario:filters.horizons.12m'),
  };
  return (
    <div className={styles.root}>
      {horizons.map(horizon => (
        <div
          key={horizon}
          className={styles.horizonItem}
          data-selected={horizon === selectedHorizon}
          onClick={() => handleHorizonChange(horizon)}
        >
          {horizonTranslationMap[horizon]}
        </div>
      ))}
    </div>
  );
};
